import { render, staticRenderFns } from "./OTableButton.vue?vue&type=template&id=f1340292&scoped=true&"
import script from "./OTableButton.vue?vue&type=script&lang=js&"
export * from "./OTableButton.vue?vue&type=script&lang=js&"
import style0 from "./OTableButton.vue?vue&type=style&index=0&id=f1340292&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1340292",
  null
  
)

export default component.exports